import axios from 'axios';
import { API_URL, API_URL_LOCAL, API_LOCAL } from "../constantes/constantes";

export async function getResults({type, sport, idEvent}) {
  // let apiURL= `../data/results.json`
  let apiURL= `${API_URL_LOCAL}${API_LOCAL}results.json`;
  console.log(`url == ${API_URL}${type}/${sport}/${idEvent}.json`);

  try {
    const { data, status } = await axios.get(apiURL, {
      timeout: 25000,
      headers: {
        'Accept': 'application/json, text/plain, */*'
      }
    });

    return { data, statusCode: status };
  } catch (error) {
    console.error("Error en getResults:", error.message || error);
    const statusCode = error.response?.status || 500;
    return { statusCode, data: [] };
  }
}